import { render, staticRenderFns } from "./communitySpacePersonManageList.vue?vue&type=template&id=223dc665&scoped=true"
import script from "./communitySpacePersonManageList.vue?vue&type=script&lang=js"
export * from "./communitySpacePersonManageList.vue?vue&type=script&lang=js"
import style0 from "./communitySpacePersonManageList.vue?vue&type=style&index=0&id=223dc665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223dc665",
  null
  
)

export default component.exports